<div>
  <span>{{metadataRepresentation.getValue()}}</span>
</div>
